import { ux1DatePrivate } from './date';
import { ux1CurrencyPrivate } from './currency';

export * from './all';

export const configCommonModules = (locale: string): void => {
	// Set locate for modules
	ux1DatePrivate.setCurrentLocale(locale);
	ux1CurrencyPrivate.setLocale(locale);
};
